// src/components/img/GalerySectionVessels/VesselmaerskBenguella.tsx
import React from 'react';
import vesselImage from './maerskBenguella.jpeg';

const VesselmaerskBenguella: React.FC = () => (
  <img src={vesselImage} alt="Vessel maerskBenguella" />
);

export default VesselmaerskBenguella;